import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const LocationTitle = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  color: var(--neutral-10);
  margin-left: 28px;
  margin-bottom: 0;
`;

export const AssignItemForm = styled.div`
  display: flex;
  gap: 16px;
`;

export const ButtonAction = styled(Button)`
  flex-shrink: 0;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  width: 25px !important;
  height: 25px !important;

  span {
    font-size: 18px;
    margin-left: 1px;
  }
`;

export const LocationTableWrapper = styled.div`
  display: flex;
  height: calc(100% - 32px);
`;

export const tableContainerStyle: React.CSSProperties = {
  paddingBottom: 32,
};
